// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LockOutlinedSvg from "@fishx/icons-svg/es/asn/LockOutlined";
import FishxIcon from '../components/FishxIcon';

var LockOutlined = function LockOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: LockOutlinedSvg
  }));
};

LockOutlined.displayName = 'LockOutlined';
export default React.forwardRef(LockOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/LockOutlined.js
// module id = 3068
// module chunks = 0